export default __webpack_public_path__ + "static/media/market-downtrend.d8686c53.png";